(function () {
  'use strict';

  const MATERIAL_PROFILES = {
    '8061637722388': {
      key: 'tela', eyebrow: 'TELA PERSONALIZZATA',
      title: 'Crea la tua tela, come la immagini',
      intro: 'La fotografia e pronta: scegli il formato reale e controlla l inquadratura prima del carrello.',
      mirroredEdge: true, services: true
    },
    '8082222022932': {
      key: 'forex', eyebrow: 'FOREX PERSONALIZZATO',
      title: 'Crea il tuo pannello Forex, come lo immagini',
      intro: 'La fotografia e pronta: scegli formato, effetto e inquadratura del pannello Forex.',
      mirroredEdge: false, services: true
    },
    '8082232181012': {
      key: 'plexy', eyebrow: 'PLEXIGLASS PERSONALIZZATO',
      title: 'Crea il tuo pannello Plexiglass, come lo immagini',
      intro: 'La fotografia e pronta: scegli formato, effetto e inquadratura del pannello Plexiglass.',
      mirroredEdge: false, services: true
    },
    '8082220155156': {
      key: 'legno', eyebrow: 'LEGNO PERSONALIZZATO',
      title: 'Crea il tuo pannello in legno, come lo immagini',
      intro: 'La fotografia e pronta: scegli formato, effetto e inquadratura del pannello in legno.',
      mirroredEdge: false, services: true
    }
  };
  const PREFERRED_FORMATS = ['20x30', '30x40', '40x60', '60x90', '80x120'];
  let currentFormatOptions = [];

  function routeProductId() {
    const value = String(new URLSearchParams(location.search).get('product') || '');
    return value.replace('gid://shopify/Product/', '');
  }

  const materialProfile = MATERIAL_PROFILES[routeProductId()];
  if (!materialProfile) {
    return;
  }

  document.documentElement.classList.add('tp-tela-approved-root', 'tp-wall-material-root');

  function usesPlainWallPresentation() {
    return ['tela', 'forex', 'plexy', 'legno'].includes(String(materialProfile.key || ''));
  }

  function hasPhoto() {
    return typeof hasReadyImage === 'function' && hasReadyImage();
  }

  function hasImageParameter() {
    return Boolean(new URLSearchParams(location.search).get('image'));
  }

  function setPhotoGate(open) {
    const gate = document.getElementById('tp-tela-photo-gate');
    const page = document.querySelector('.configurator-page');
    document.body.classList.toggle('tp-tela-gate-open', Boolean(open));
    if (gate) {
      gate.hidden = !open;
      gate.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    if (page) {
      page.setAttribute('aria-hidden', open ? 'true' : 'false');
    }
  }

  function syncPhotoGate() {
    setPhotoGate(!hasPhoto() && !hasImageParameter());
  }

  function updateGateContext() {
    const context = document.getElementById('tp-tela-photo-gate-context');
    if (!context) {
      return;
    }
    const params = new URLSearchParams(location.search);
    const requested = params.get('format');
    const orientation = params.get('orientation');
    const selected = currentSelectedItem();
    const format = requested || (selected ? normalizedMeasure(selected).replace('x', ' × ') : '');
    const orientationLabel = orientation === 'portrait'
      ? 'verticale'
      : (orientation === 'landscape' ? 'orizzontale' : '');
    context.textContent = format
      ? `Formato preselezionato: ${format}${orientationLabel ? ` · ${orientationLabel}` : ''}. La scelta resterà attiva dopo il caricamento.`
      : `Dopo la scelta della foto potrai selezionare uno dei ${currentFormatOptions.length || 25} formati disponibili.`;
  }

  function normalizedMeasure(item) {
    const width = Number(item && item.width);
    const height = Number(item && item.height);
    if (!Number.isFinite(width) || !Number.isFinite(height)) {
      return '';
    }
    return [Math.min(width, height), Math.max(width, height)].join('x');
  }

  function selectedOptionIndex() {
    const selected = document.querySelector('.measure input[type="radio"]:checked');
    if (!selected) {
      return -1;
    }
    const match = String(selected.id || '').match(/option-(\d+)/);
    return match ? Number(match[1]) : -1;
  }

  function recommendedIndexes(items) {
    const indexes = [];
    for (const preferred of PREFERRED_FORMATS) {
      const index = items.findIndex((item) => normalizedMeasure(item) === preferred);
      if (index >= 0 && !indexes.includes(index)) {
        indexes.push(index);
      }
    }
    for (let index = 0; indexes.length < 3 && index < items.length; index += 1) {
      if (!indexes.includes(index)) {
        indexes.push(index);
      }
    }
    return indexes.slice(0, 5);
  }

  function currentSelectedItem() {
    const index = selectedOptionIndex();
    const items = currentFormatOptions.length
      ? currentFormatOptions
      : (typeof availableOptions !== 'undefined' ? availableOptions : []);
    return index >= 0 && items[index] ? items[index] : null;
  }

  function validPriceState(item) {
    if (!item || item.available === false) {
      return false;
    }
    const price = Number(item.price);
    const compare = Number(item.compareAtPrice) || 0;
    return Number.isFinite(price) && price > 0 && (compare === 0 || compare >= price);
  }

  function syncCanvasAspectAndVariant() {
    const item = currentSelectedItem();
    const wrapper = document.getElementById('canvas-container-wrapper');
    const footer = document.querySelector('.configurator-action-footer');
    if (!item || !wrapper) {
      return;
    }
    const width = Number(item.width);
    const height = Number(item.height);
    if (Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0) {
      wrapper.style.setProperty('--tp-canvas-ratio', `${width} / ${height}`);
      wrapper.dataset.widthCm = String(width);
      wrapper.dataset.heightCm = String(height);
      boundCanvasStage(wrapper, width, height);
    }
    if (footer) {
      footer.dataset.selectedVariantId = String(item.id || '');
      footer.dataset.selectedPrice = String(item.price ?? '');
      footer.dataset.selectedCompareAt = String(item.compareAtPrice ?? '');
    }
  }

  function boundCanvasStage(wrapper, width, height) {
    if (!wrapper || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
      return;
    }
    if (window.innerWidth <= 767) {
      wrapper.style.removeProperty('width');
      wrapper.style.removeProperty('max-width');
      return;
    }
    const card = wrapper.closest('.container-configuration') || wrapper.parentElement;
    const measuredCardWidth = card && card.clientWidth > 360
      ? card.clientWidth
      : Math.min(window.innerWidth * 0.62, 1040);
    const availableWidth = Math.max(225, measuredCardWidth - 92);
    const desktop = window.innerWidth >= 1024;
    const maxHeight = desktop
      ? Math.min(390, Math.max(300, window.innerHeight - 553))
      : Math.min(420, Math.max(300, window.innerHeight - 590));
    const fromHeight = maxHeight * (width / height);
    const targetWidth = Math.max(225, Math.min(580, availableWidth, fromHeight));
    wrapper.style.setProperty('width', `${targetWidth}px`, 'important');
    wrapper.style.setProperty('max-width', `${targetWidth}px`, 'important');
  }

  function installVisualHierarchy() {
    const page = document.querySelector('.configurator-page');
    const options = document.querySelector('.configurator-options');
    const preview = document.querySelector('.configurator-preview');
    const header = document.querySelector('.configurator-header');
    const footer = document.querySelector('.configurator-action-footer');
    if (!page || !options || !preview || !header || !footer) {
      return;
    }
    page.classList.add('tp-tela-visual-shell');
    if (footer.parentElement !== options) {
      options.appendChild(footer);
    }
    const formatHead = document.querySelector('.tp-tela-format-head');
    const formatHeadLabel = formatHead && formatHead.querySelector('strong');
    const orientationButton = document.getElementById('tp-tela-orientation-toggle');
    if (formatHeadLabel) {
      formatHeadLabel.textContent = 'Scegli formato';
    }
    if (formatHead && orientationButton && orientationButton.parentElement !== formatHead) {
      formatHead.appendChild(orientationButton);
    }
    const mainTitle = header.querySelector('.configurator-main-title');
    const previewTitle = document.querySelector('.preview-title');
    const previewEyebrow = document.querySelector('.preview-eyebrow');
    const previewCopy = previewEyebrow && previewEyebrow.parentElement;
    if (mainTitle && previewCopy) {
      mainTitle.textContent = materialProfile.title;
      mainTitle.classList.add('tp-tela-preview-main-title');
      previewEyebrow.insertAdjacentElement('afterend', mainTitle);
    }
    if (previewTitle) {
      previewTitle.remove();
    }
    if (previewEyebrow) {
      previewEyebrow.lastChild.textContent = ' Foto caricata';
    }
    const fixedEdge = document.querySelector('.tp-tela-fixed-edge');
    if (fixedEdge && !materialProfile.mirroredEdge) {
      fixedEdge.hidden = true;
      fixedEdge.setAttribute('aria-hidden', 'true');
    }
    header.remove();
  }

  function dockIlariaWithoutOverlap() {
    const button = document.querySelector('.tp-il-prelaunch');
    const footer = document.querySelector('.configurator-action-footer');
    if (!button || !footer) {
      return;
    }
    if (window.matchMedia('(max-width: 1023px)').matches) {
      if (button.parentElement !== footer) {
        footer.appendChild(button);
      }
      return;
    }
    if (button.parentElement === footer) {
      document.body.appendChild(button);
    }
  }

  function installIlariaDock() {
    dockIlariaWithoutOverlap();
    const observer = new MutationObserver(dockIlariaWithoutOverlap);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', dockIlariaWithoutOverlap, { passive: true });
  }

  function installResponsiveFooter() {
    const footer = document.querySelector('.configurator-action-footer');
    if (!footer) {
      return;
    }
    let naturalTop = 0;
    const update = () => {
      if (!window.matchMedia('(max-width: 767px)').matches) {
        footer.classList.remove('tp-tela-sticky-ready');
        return;
      }
      const threshold = naturalTop + footer.offsetHeight - window.innerHeight;
      footer.classList.toggle('tp-tela-sticky-ready', window.scrollY >= threshold);
    };
    const measure = () => {
      footer.classList.remove('tp-tela-sticky-ready');
      naturalTop = footer.getBoundingClientRect().top + window.scrollY;
      update();
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    requestAnimationFrame(measure);
    window.setTimeout(measure, 600);
    window.setTimeout(measure, 1600);
  }

  function ensureFormatDrawer() {
    let drawer = document.getElementById('tp-tela-format-drawer');
    if (drawer) {
      return drawer;
    }
    drawer = document.createElement('div');
    drawer.id = 'tp-tela-format-drawer';
    drawer.className = 'tp-tela-format-drawer';
    drawer.hidden = true;
    drawer.innerHTML = `
      <div class="tp-tela-format-drawer-backdrop" data-tp-format-close></div>
      <section class="tp-tela-format-drawer-panel" role="dialog" aria-modal="true" aria-labelledby="tp-tela-format-drawer-title">
        <header class="tp-tela-format-drawer-head">
          <div>
            <span>Tutti i formati disponibili</span>
            <h2 id="tp-tela-format-drawer-title">Scegli misura e prezzo</h2>
          </div>
          <button type="button" class="tp-tela-format-drawer-close" data-tp-format-close aria-label="Chiudi elenco formati">×</button>
        </header>
        <div class="tp-tela-format-drawer-grid" id="tp-tela-format-drawer-grid"></div>
      </section>`;
    document.body.appendChild(drawer);
    drawer.querySelectorAll('[data-tp-format-close]').forEach((button) => {
      button.addEventListener('click', closeFormatDrawer);
    });
    return drawer;
  }

  function closeFormatDrawer() {
    const drawer = document.getElementById('tp-tela-format-drawer');
    const toggle = document.getElementById('tp-tela-format-toggle');
    if (drawer) {
      drawer.hidden = true;
    }
    document.body.classList.remove('tp-tela-format-drawer-open');
    toggle && toggle.setAttribute('aria-expanded', 'false');
  }

  function renderFormatDrawer(items) {
    const drawer = ensureFormatDrawer();
    const grid = drawer.querySelector('#tp-tela-format-drawer-grid');
    if (!grid || !Array.isArray(items)) {
      return;
    }
    const selected = selectedOptionIndex();
    grid.innerHTML = '';
    items.forEach((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tp-tela-format-choice';
      button.dataset.index = String(index);
      button.classList.toggle('is-selected', index === selected);
      button.setAttribute('aria-pressed', index === selected ? 'true' : 'false');
      const original = usesPlainWallPresentation() ? 0 : (Number(item.compareAtPrice) || 0);
      const current = Number(item.price) || 0;
      button.innerHTML = `
        <strong>${formatMeasurement(item.width)} × ${formatMeasurement(item.height)} cm</strong>
        <span>${original > current ? `<del>${parsePrice(original)}</del>` : ''}${parsePrice(current)}</span>`;
      button.addEventListener('click', () => {
        changeOption(index, hasPhoto());
        closeFormatDrawer();
      });
      grid.appendChild(button);
    });
  }

  function openFormatDrawer() {
    const drawer = ensureFormatDrawer();
    renderFormatDrawer(currentFormatOptions.length ? currentFormatOptions : (typeof availableOptions !== 'undefined' ? availableOptions : []));
    drawer.hidden = false;
    document.body.classList.add('tp-tela-format-drawer-open');
    const toggle = document.getElementById('tp-tela-format-toggle');
    toggle && toggle.setAttribute('aria-expanded', 'true');
  }

  function enhanceFormatRows(items) {
    currentFormatOptions = Array.isArray(items) ? items.slice() : [];
    const rows = Array.from(document.querySelectorAll('.measure > tr'));
    const recommended = recommendedIndexes(currentFormatOptions);
    rows.forEach((row, index) => {
      row.classList.add('tp-tela-approved-row');
      row.dataset.tpRecommended = recommended.includes(index) ? 'true' : 'false';
      row.dataset.tpRecommendedOrder = recommended.includes(index) ? String(recommended.indexOf(index) + 1) : '';
      const input = row.querySelector('input[type="radio"]');
      const item = currentFormatOptions[index];
      row.setAttribute('role', 'radio');
      row.tabIndex = 0;
      row.setAttribute('aria-checked', input && input.checked ? 'true' : 'false');
      if (input && item) {
        input.setAttribute(
          'aria-label',
          `${formatMeasurement(item.width)} per ${formatMeasurement(item.height)} centimetri, ${parsePrice(Number(item.price) || 0)}`
        );
      }
      if (!row.dataset.tpKeyboardReady) {
        row.dataset.tpKeyboardReady = 'true';
        row.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }
          event.preventDefault();
          changeOption(index, hasPhoto());
        });
      }
    });
    const count = document.getElementById('tp-tela-format-count');
    if (count) {
      count.textContent = String(rows.length);
    }
    const card = document.querySelector('.format-card');
    const toggle = document.getElementById('tp-tela-format-toggle');
    if (card && toggle) {
      toggle.textContent = `Vedi tutti i ${rows.length} formati`;
    }
    renderFormatDrawer(currentFormatOptions);
  }

  function extrasTotal() {
    if (typeof getExtras !== 'function') {
      return 0;
    }
    return getExtras().reduce((sum, extra) => sum + (Number(extra.price) || 0), 0);
  }

  function selectedEffect() {
    if (typeof getFilter !== 'function') {
      return 'Nessuno';
    }
    return getFilter();
  }

  function selectedServices() {
    if (typeof getExtras !== 'function') {
      return [];
    }
    return getExtras().map((extra) => extra.title);
  }

  function updateTotalPrice() {
    const price = document.querySelector('.price');
    const button = document.getElementById('btn-add-to-card');
    const label = button && button.querySelector('.add-to-cart-label');
    if (!price) {
      return;
    }
    const item = currentSelectedItem();
    if (!item) {
      price.innerHTML = '<span class="tp-tela-price-loading">Caricamento prezzoâ€¦</span>';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.priceLoading = 'true';
      }
      if (label) {
        label.textContent = 'Caricamento prezzoâ€¦';
      }
      return;
    }
    if (!validPriceState(item)) {
      price.innerHTML = '<span class="tp-tela-price-error">Prezzo non disponibile</span>';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.priceInvalid = 'true';
        delete button.dataset.priceLoading;
      }
      if (label) {
        label.textContent = 'Prezzo non disponibile';
      }
      return;
    }
    const base = Number(item.price) || 0;
    const extras = extrasTotal();
    const total = base + extras;
    const original = usesPlainWallPresentation() ? 0 : (Number(item.compareAtPrice) || 0);
    const discounted = original > base;
    const discount = discounted ? Math.round((1 - base / original) * 100) : 0;
    price.innerHTML = `
      <div class="total-price-wrap">
        ${discounted ? `<span class="total-old-price">${parsePrice(original + extras)}</span><span class="total-discount-badge">-${discount}%</span>` : ''}
        <span class="total-final-price">${parsePrice(total)}</span>
        ${extras > 0 ? `<span class="tp-tela-extra-price">Servizi extra inclusi: ${parsePrice(extras)}</span>` : ''}
      </div>
    `;
    if (button) {
      delete button.dataset.priceInvalid;
      delete button.dataset.priceLoading;
      button.disabled = !hasPhoto();
      button.setAttribute('aria-disabled', hasPhoto() ? 'false' : 'true');
    }
    if (label) {
      label.textContent = hasPhoto() ? 'Aggiungi al carrello' : 'Foto richiesta';
    }
  }

  function updateTechnicalStatus() {
    const node = document.getElementById('tp-tela-technical-status');
    if (!node) {
      return;
    }
    if (!hasPhoto() || typeof option === 'undefined' || !option || typeof imgSource === 'undefined') {
      node.hidden = true;
      return;
    }
    const width = Number(imgSource.naturalWidth);
    const height = Number(imgSource.naturalHeight);
    const cmWidth = Number(option.width);
    const cmHeight = Number(option.height);
    if (![width, height, cmWidth, cmHeight].every((value) => Number.isFinite(value) && value > 0)) {
      node.hidden = true;
      return;
    }
    const pxPerCm = Math.round(Math.min(width / cmWidth, height / cmHeight));
    node.hidden = false;
    node.textContent = `Controllo tecnico: file ${width} × ${height} px · circa ${pxPerCm} pixel/cm sul formato selezionato. Usa il file originale quando disponibile.`;
  }

  function updateSummary() {
    const measure = document.getElementById('tp-tela-summary-measure');
    const effect = document.getElementById('tp-tela-summary-effect');
    const services = document.getElementById('tp-tela-summary-services');
    if (measure && typeof option !== 'undefined' && option) {
      measure.textContent = `${formatMeasurement(option.width)} × ${formatMeasurement(option.height)} cm`;
    }
    if (effect) {
      effect.textContent = selectedEffect();
    }
    if (services) {
      const names = selectedServices();
      services.textContent = names.length ? names.join(', ') : 'Nessuno';
    }
  }

  function updatePath() {
    const path = document.getElementById('tp-tela-path');
    if (!path) {
      return;
    }
    const photoReady = hasPhoto();
    const extras = selectedServices().length > 0;
    Array.from(path.children).forEach((item, index) => {
      item.classList.remove('is-active', 'is-complete');
      if (!photoReady) {
        item.classList.toggle('is-active', index === 0);
      } else if (index < 2) {
        item.classList.add('is-complete');
      } else if (index === 2 && !extras) {
        item.classList.add('is-active');
      } else if (index < 3) {
        item.classList.add('is-complete');
      } else {
        item.classList.add('is-active');
      }
    });
  }

  function updatePhotoState() {
    const roomButton = document.getElementById('tp-tela-room-button');
    const editButton = document.getElementById('tp-tela-edit-toggle');
    const ready = hasPhoto();
    if (roomButton) {
      roomButton.disabled = !ready;
    }
    if (editButton) {
      editButton.disabled = !ready;
    }
    updateTechnicalStatus();
    updateSummary();
    updatePath();
    syncPhotoGate();
    updateGateContext();
  }

  function updateAll() {
    syncCanvasAspectAndVariant();
    updateTotalPrice();
    updatePhotoState();
  }

  const originalCreateOptions = window.createOptions;
  if (typeof originalCreateOptions === 'function') {
    window.createOptions = function (items) {
      const result = originalCreateOptions.apply(this, arguments);
      enhanceFormatRows(items);
      return result;
    };
  }

  const originalChangeOption = window.changeOption;
  if (typeof originalChangeOption === 'function') {
    window.changeOption = function () {
      const result = originalChangeOption.apply(this, arguments);
      enhanceFormatRows(currentFormatOptions.length ? currentFormatOptions : (typeof availableOptions !== 'undefined' ? availableOptions : []));
      syncCanvasAspectAndVariant();
      updateAll();
      return result;
    };
  }

  const originalSetPrice = window.setPrice;
  if (typeof originalSetPrice === 'function') {
    window.setPrice = function () {
      const result = originalSetPrice.apply(this, arguments);
      updateTotalPrice();
      updateSummary();
      return result;
    };
  }

  const originalChangeFilter = window.changeFilter;
  if (typeof originalChangeFilter === 'function') {
    window.changeFilter = function () {
      const result = originalChangeFilter.apply(this, arguments);
      updateSummary();
      updatePath();
      return result;
    };
  }

  const originalOnClickExtra = window.onClickExtra;
  if (typeof originalOnClickExtra === 'function') {
    window.onClickExtra = function () {
      const result = originalOnClickExtra.apply(this, arguments);
      updateAll();
      return result;
    };
  }

  const originalPhotoState = window.setPhotoRequiredState;
  if (typeof originalPhotoState === 'function') {
    window.setPhotoRequiredState = function () {
      const result = originalPhotoState.apply(this, arguments);
      queueMicrotask(() => {
        updatePhotoState();
        updateTotalPrice();
      });
      return result;
    };
  }

  const originalInitializeWithoutImage = window.initializeWithoutImage;
  if (typeof originalInitializeWithoutImage === 'function') {
    window.initializeWithoutImage = function () {
      const result = originalInitializeWithoutImage.apply(this, arguments);
      queueMicrotask(() => {
        syncPhotoGate();
        updateGateContext();
      });
      return result;
    };
  }

  function installControls() {
    document.body.classList.add('tp-tela-approved', 'tp-wall-material', `tp-material-${materialProfile.key}`);
    document.body.dataset.tpMaterial = materialProfile.key;
    installVisualHierarchy();

    const gateEyebrow = document.querySelector('.tp-tela-photo-gate-eyebrow');
    const gateCopy = document.querySelector('.tp-tela-photo-gate-copy');
    const title = document.querySelector('.configurator-main-title');
    const intro = document.querySelector('.configurator-intro');
    if (gateEyebrow) {
      gateEyebrow.textContent = materialProfile.eyebrow;
    }
    if (gateCopy) {
      gateCopy.textContent = 'Seleziona prima il file originale. Subito dopo potrai scegliere formato, orientamento, effetto e servizi disponibili.';
    }
    if (title) {
      title.textContent = materialProfile.title;
    }
    if (intro) {
      intro.textContent = materialProfile.intro;
    }

    document.querySelectorAll('.effect-card .step-number, .extras-card .step-number').forEach((node) => {
      node.textContent = '3';
    });
    const formatStep = document.querySelector('.format-card .step-number');
    if (formatStep) {
      formatStep.textContent = '2';
    }

    const gateButton = document.getElementById('tp-tela-photo-gate-button');
    if (gateButton) {
      gateButton.addEventListener('click', () => loadImage());
    }
    const changePhotoButton = document.getElementById('tp-tela-change-photo');
    if (changePhotoButton) {
      changePhotoButton.textContent = 'Scegli un’altra foto';
      changePhotoButton.addEventListener('click', () => loadImage());
    }
    document.querySelectorAll('.btn-change-image').forEach((legacyButton) => {
      legacyButton.hidden = true;
      legacyButton.setAttribute('aria-hidden', 'true');
      legacyButton.setAttribute('tabindex', '-1');
    });

    const formatCard = document.querySelector('.format-card');
    const formatToggle = document.getElementById('tp-tela-format-toggle');
    if (formatCard && formatToggle) {
      formatToggle.addEventListener('click', openFormatDrawer);
    }

    const orientationButton = document.getElementById('tp-tela-orientation-toggle');
    if (orientationButton) {
      orientationButton.addEventListener('click', () => {
        const index = selectedOptionIndex();
        if (index < 0 || typeof availableOptions === 'undefined' || !availableOptions[index]) {
          return;
        }
        const selected = availableOptions[index];
        const width = selected.width;
        selected.width = selected.height;
        selected.height = width;
        changeOption(index, hasPhoto());
      });
    }

    const extrasTable = document.getElementById('tbody-servizi');
    if (extrasTable) {
      extrasTable.addEventListener('change', updateAll);
    }

    const editButton = document.getElementById('tp-tela-edit-toggle');
    if (editButton) {
      editButton.addEventListener('click', () => {
        const editing = document.body.classList.toggle('tp-tela-editing');
        editButton.setAttribute('aria-pressed', editing ? 'true' : 'false');
        editButton.textContent = editing ? 'Termina regolazione' : 'Regola la foto';
      });
    }

    const room = document.getElementById('tp-tela-room');
    const roomImage = document.getElementById('tp-tela-room-image');
    const roomButton = document.getElementById('tp-tela-room-button');
    const closeRoom = document.getElementById('tp-tela-room-close');
    if (room && roomButton && roomImage) {
      roomButton.addEventListener('click', () => {
        if (!hasPhoto() || typeof canvas === 'undefined' || !canvas) {
          return;
        }
        roomImage.src = canvas.toDataURL({ format: 'jpeg', quality: 0.82 });
        room.hidden = false;
      });
      const close = () => {
        room.hidden = true;
      };
      closeRoom && closeRoom.addEventListener('click', close);
      room.addEventListener('click', (event) => {
        if (event.target === room) {
          close();
        }
      });
    }

    enhanceFormatRows(typeof availableOptions !== 'undefined' ? availableOptions : []);
    updateAll();
    syncPhotoGate();
    updateGateContext();
    installIlariaDock();
    installResponsiveFooter();
    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(syncCanvasAspectAndVariant);
    }, { passive: true });
    requestAnimationFrame(syncCanvasAspectAndVariant);
  }

  document.addEventListener('DOMContentLoaded', installControls);
})();
